import { BookingType } from "../../../../features/Booking-Form/typings/booking-inputs";
import {
  BookingRequestsStatus,
  PatchActiveBookingRequestsDto
} from "../../../BookingRequest/typings/booking-requests.types";
import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";

/** PATCH `/booking-approval/status` for the parent booking; no-op if detail is missing. */
export async function patchAssociatedBookingApproval(
  detailData: DetailedServiceBookingData | null,
  patchBookingRequest: (dto: PatchActiveBookingRequestsDto) => Promise<void>
): Promise<void> {
  if (!detailData) {
    return;
  }

  await patchBookingRequest({
    status: BookingRequestsStatus.APPROVED,
    bookingData: [
      {
        bookingId: Number(detailData.bookingId),
        bookingType:
          detailData.placeOrZoneType === "zone" ? BookingType.CONFERENCEZONE : BookingType.WORKPLACE
      }
    ]
  });
}
